<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<h2 mat-dialog-title  cdkDragHandle>{{title}}</h2>

<mat-dialog-content [ngClass]="{ 'no-spinner': !isSpinner }">
<ng-container *ngIf="isAddNew">
    <table style="align-items: center;text-align: left;padding-top: 15px;">
        <tbody>
            <tr>
                <td></td>
                <td>
                    <mat-form-field #textboxmatformfind class="mat-form-field-no-padding" appearance="outline" floatLabel="always" style="max-width: 150px;">
                        <mat-label>{{findLabel}}</mat-label>
                        <ng-container *ngIf="isPositiveInteger; else defaultfind">
                            <input type="number" id="add-input" cdkFocusInitialstyle="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="viewModel.find" placeholder="{{findPlaceholder}}" [min]="0" [max]="1000">
                        </ng-container>
                        <ng-template #defaultfind>
                            <input type="number"id="add-input" style="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="viewModel.find" placeholder="{{findPlaceholder}}">
                        </ng-template>
                        <div matPrefix  class="colorBox" [style.backgroundColor]="viewModel.currentColor.color"></div>
                    </mat-form-field>
                </td>
                <td ><span class="symbolbox" [style.color]="viewModel.currentColor.color"  style="margin-right: 4px;">{{symbol}}</span> </td>
                <td>
                    <mat-form-field #textboxmatformreplace class="mat-form-field-no-padding" style="max-width: 150px;margin-right: 10px;" appearance="outline" floatLabel="always">
                        <mat-label>{{replaceLabel}}</mat-label>
                        <ng-container *ngIf="isPositiveInteger; else defaultreplace">
                            <input type="number" id="add-input" style="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="viewModel.replace" placeholder="{{replacePlaceholder}}" appIntegerPositiveOnly>
                        </ng-container>
                        <ng-template #defaultreplace>
                            <input type="number" id="add-input" style="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="viewModel.replace" placeholder="{{replacePlaceholder}}">
                        </ng-template>
                        <div matPrefix  class="colorBox" [style.backgroundColor]="viewModel.currentColor.color"></div>
                    </mat-form-field>
                </td>
                <td> 
                    <button title="Add" (click)="addItem()" mat-icon-button style="margin-left: -15px;">
                        <mat-icon class="icon" color="primary">add_box</mat-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
    <div class="dashed-line"></div>
</ng-container>
<table style="align-items: center;text-align: left;padding-top: 5px;">
    <ng-container *ngIf="isShowHeader">
        <thead>
            <th style="font-weight: normal;">Source Field</th>
            <th style="font-weight: normal;padding-left:10px;">Start</th>
            <th> </th>
            <th style="font-weight: normal;padding-left:10px;">End</th>
            <th> </th>
        </thead>
    </ng-container>
    <tbody>
        <ng-container *ngFor="let item of viewModel.textItems;let i = index">
            <tr>
                <td>
                    <span *ngIf="isShowHeader" style="flex: 1;" [style.color]="viewModel.sourceItems[i]?.color">
                    {{ viewModel.sourceItems[i]?.text }}
                    </span>
                </td>
                <td>
                    <mat-form-field class="mat-form-field-no-padding" style="max-width: 150px;" appearance="outline" floatLabel="auto">
                        <mat-label>{{findLabel}}</mat-label>
                        <ng-container *ngIf="isPositiveInteger; else defaultfindInput">
                            <input type="number" id="add-input" [id]="'findInput' + i" (keydown.enter)="focusNext(i + 1)" style="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="item.find" placeholder="{{findPlaceholder}}" required appIntegerPositiveOnly>
                        </ng-container>
                        <ng-template #defaultfindInput>
                            <input type="number" id="add-input" [id]="'findInput' + i" (keydown.enter)="focusNext(i + 1)" style="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="item.find" placeholder="{{findPlaceholder}}" required>
                        </ng-template>
                        <div matPrefix  class="colorBox" [style.backgroundColor]="item.color.color"></div>
                    </mat-form-field>
                </td>
                <td>
                    <span class="symbolbox" style="margin-right: 3px;">{{symbol}}</span>
                </td>
                <td>
                    <mat-form-field class="mat-form-field-no-padding" style="margin-right: 10px;max-width: 150px;margin-left: -4px;" appearance="outline" floatLabel="auto">
                        <mat-label>{{replaceLabel}}</mat-label>
                        <ng-container *ngIf="isPositiveInteger; else defaultreplaceInput">
                            <input type="number" id="add-input" [id]="'replaceInput' + i" (keydown.enter)="focusNext(i + 1)" style="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="item.replace" placeholder="{{replacePlaceholder}}" required appIntegerPositiveOnly>
                        </ng-container>
                        <ng-template #defaultreplaceInput>
                            <input type="number" id="add-input" [id]="'replaceInput' + i" (keydown.enter)="focusNext(i + 1)" style="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="item.replace" placeholder="{{replacePlaceholder}}" required>
                        </ng-template>
                        <div matPrefix  class="colorBox" [style.backgroundColor]="item.color.color"></div>
                    </mat-form-field>
                </td>
                <td>
                    <ng-container *ngIf="isAddNew">
                        <button mat-icon-button style="margin-left: -20px;"  (click)="deleteItem(item)">
                            <mat-icon class="icon red-icon" >delete_forever</mat-icon>
                        </button>
                    </ng-container>
                </td>
            </tr>
        </ng-container>
    </tbody>
</table>
    <div *ngIf="!isShowHeader">
        <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
            *ngFor="let containItem of viewModel.sourceItems"
            [style.color]="containItem.color.color">{{containItem.text }} </span>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" style=" margin-right: 40px ;">
    <button (click)="save()" class="save-btn" color="primary" mat-raised-button >SAVE</button>
    <button (click)="cancel()" mat-raised-button mat-dialog-close >CANCEL</button>
</mat-dialog-actions>
</div>